<template>
    <modal
        name="agency-lead"
        ref="lead"
        extra-class="bottom-modal lead-modal"
    >
        <template slot="body" slot-scope="props">
            <agency-lead-form :agency-id="props.data" />
        </template>
    </modal>
</template>

<script>
import AgencyLeadForm from '../form/AgencyLeadForm'
import Modal from '../Modal'

export default {
    components: {
        'agency-lead-form': AgencyLeadForm,
        'modal': Modal,
    },
}
</script>